import { render, staticRenderFns } from "./InputMask.vue?vue&type=template&id=5d84f197&scoped=true"
import script from "./InputMask.vue?vue&type=script&lang=js"
export * from "./InputMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d84f197",
  null
  
)

export default component.exports